import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";


const API_URL = `${process.env.REACT_APP_API_URL}`; 


export const fetchContactInfoQuery = async () => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/contact-info/get-contact-info`, { headers: customHeaders });
  return response.data;
};

export const updateContactInfoQuery = async (updatedContactInfo: { email: string; phone: string; }) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  
  const response = await axiosInstance.post(`${API_URL}/contact-info/update-contact-info`, updatedContactInfo, { headers: customHeaders });
  return response.data;
};